import React from 'react';

const Notice = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11 7V15C11 15.5523 10.5523 16 10 16C9.44771 16 9 15.5523 9 15V7H11ZM11 6V4H9V6H11Z"
      fill="#0073F7"
    />
  </svg>
);

export default Notice;
